import { env } from '@/utils/env';

export default HTTPClient => ({
  getLoggedUser: () => HTTPClient.get('/user/me').then(resp => resp.data),
  searchUsersByGroups: async ({
    term = '',
    page = 0,
    perPage = 100,
    groups = [],
  } = {}) => {
    const groupParams = groups.map(group => `&groups[]=${group}`).join('');
    const url = `/user?order_by=full_name&sort=asc&query=${term}&page=${page}&per_page=${perPage}${groupParams}`;
    const { data } = await HTTPClient.get(url);

    return data;
  },
  getUsersByGroup: async ({ page = 0, perPage = 100, group = '' } = {}) => {
    const url = `/groups/${group}/users?order_by=fullname&sort=asc&page=${page}&per_page=${perPage}`;
    const { data } = await HTTPClient.get(url);

    return data;
  },
  getUserById: async (id) => {
    const url = `/user/${id}`;
    const { data } = await HTTPClient.get(url);

    return data;
  },
  getGroupTeacherId: () => env.VUE_APP_GROUP_TEACHER_ID,
  getGroupOperatorId: () => env.VUE_APP_GROUP_OPERATOR_ID,
  getGroupAdminId: () => env.VUE_APP_GROUP_ADMIN_ID,
});
